'use strict';

const getBirthdayFromCookie = require('./getBirthdayFromCookie');
const legalAge = require('./legalAge');

module.exports = function getAgeFromCookie () {
  let birthday = getBirthdayFromCookie();

  if (birthday) {
    return legalAge(new Date(), birthday);
  } else {
    return undefined;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-agegate/getAgeFromCookie.js